export enum ImpSection {
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_DETAIL2 = 'FLIGHT_DETAIL2',
}

export enum RecoType {
  CVR = 'CVR',
  TOP_CLK = 'TOP_CLK',
}

interface IHotelInfo {
  clkLogUrl: string;
  id: string;
  image: string;
  name: string;
  overallRating: number;
  price: number;
}

export interface IStatsRecommendedHotels {
  hotelsInfo: IHotelInfo[];
  impLogUrl: string;
}
